<template>
  <div class="box">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 右边内容 -->
    <div class="content-right">
      <!-- 目录 -->
      <div class="person-list">
        <el-tabs
          v-model="mydata.activeName"
          class="demo-tabs"
          @tab-change="handleChange"
          :key="mydata.myKey1"
        >
          <el-tab-pane
            v-for="(item, index) in mydata.typeListArr"
            :key="index"
            :label="item.label"
            :name="item.name"
          >
          </el-tab-pane>

          <testQuestionsContentOne
            v-if="String(mydata.activeName) === '1'"
          ></testQuestionsContentOne>
          <booksContentTwo
            v-if="String(mydata.activeName) === '2'"
          ></booksContentTwo>
          <articleContentThree
            v-if="String(mydata.activeName) === '3'"
          ></articleContentThree>
          <activityContentFour
            v-if="String(mydata.activeName) === '4'"
          ></activityContentFour>
          <videoFive v-if="String(mydata.activeName) === '5'"></videoFive>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// 是否来自其他模块
let fromOtherModule = false;
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "myCollection",
  beforeRouteEnter(to, from, next) {
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
    if (
      [
        "/layout/list/topicSubjectDetails",
        "/layout/list/booksDetails",
        "/layout/list/researchDetails",
        "/layout/list/thematicDetails",
        "/layout/list/onlineDetails",
      ].includes(from.path) === false
    ) {
      fromOtherModule = true;
      // console.log('来自其他模块');
    }
    next();
  },
});
</script>



<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import { useRouter } from "vue-router";

import { reactive, computed, toRefs, onActivated } from "vue";

import testQuestionsContentOne from "@/views/personalCenter/myCollection/components/testQuestionsContentOne/index.vue";

import booksContentTwo from "@/views/personalCenter/myCollection/components/booksContentTwo/index.vue";

import articleContentThree from "@/views/personalCenter/myCollection/components/articleContentThree/index.vue";

import activityContentFour from "@/views/personalCenter/myCollection/components/activityContentFour/index.vue";

import videoFive from "@/views/personalCenter/myCollection/components/videoFive/index.vue";

// 获取收藏类型列表
import { typeList } from "@/api/personalCenter/myCollection/index.js";

// import { ElMessage } from 'element-plus'
// import { ComponentSize, FormInstance, FormRules } from "element-plus";

// import {
//   Delete,
//   Download,
//   Plus,
//   ZoomIn,
//   Warning,
// } from "@element-plus/icons-vue";

// import { UploadFile } from "element-plus";

const router = useRouter();

const mydata = reactive({
  size: "default",

  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  activeName: "1", //激活
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  typeListArr: [], //收藏类型列表
  myKey1: new Date().getTime() - Math.random(),
});

onActivated(() => {
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
    mydata.activeName = "1"; //激活
    mydata.typeListArr = []; //收藏类型列表
    mydata.myKey1 = new Date().getTime() - Math.random();
    typeListFn();
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false;

  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  // getSubject();
});

// 获取类型列表
function typeListFn() {
  typeList(mydata.userInfo.jwt).then((res) => {
    // 操作数据
    let keyArr = Object.keys(res.data);
    let valuesArr = Object.values(res.data);
    let arr = keyArr.map((item, index) => {
      return {
        label: valuesArr[index],
        name: item,
      };
    });

    // 类型列表
    mydata.typeListArr = arr;
    // 默认激活
    mydata.activeName = mydata.typeListArr[0].name;
  });
}

// 查询
// typeListFn();

function handleChange() {
  // console.log(mydata.activeName);
}
</script>

<style scoped lang="scss">
.box {
  ////右边内容
  .content-right {
    // width: 1012px;
    // height: 784px;
    margin-top: 16px;
    background-color: #ffffff;
    // padding-left: 62px;

    // border:1px solid rgb(0, 255, 34);
    //标题个人信息
    .person-list {
      // border:1px solid red;
      ////整体目录list
      :deep(.el-tabs__header.is-top) {
        margin-bottom: 0px;
        // border:1px solid rgb(26, 0, 18);
      }
      //目录左边箭头
      :deep(.el-tabs__nav-prev) {
        display: none;
      }
      //目录右边箭头
      :deep(.el-tabs__nav-next) {
        display: none;
      }
      //目录宽度
      :deep(.el-tabs__nav-wrap.is-scrollable.is-top) {
        padding: 0px;
      }
      /////整体宽度字的宽度
      :deep(.el-tabs__nav.is-top) {
        // border: 1px solid blue;
        width: 375px !important;
        height: 56px;
        padding: 0px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      //////每个字体
      :deep(.el-tabs__item.is-top) {
        // width: 111px;
        text-align: center;
        padding: 0px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        // border:1px solid green;
        // color:#333333;
      }

      :deep(.el-tabs__item.is-top:hover) {
        color: #009de0;
      }

      :deep(.el-tabs__item.is-top.is-active) {
        font-weight: 700;
        color: #009de0;
      }

      // 目录的内容
      :deep(.demo-tabs > .el-tabs__content) {
        // width: 343px;
        // min-height: 500px;
        // border: 1px solid red;
        background-color: #ffffff;
        // border-radius: 8px;
        margin: 0px;
        margin: 0 auto;
      }
    }
  }
}

//////////分页
// .paging {
//   // margin: 0 auto;
//   display: flex;
//   justify-content: center;
//   margin-top: 40px;
//   // margin-bottom:40px;
//   :deep(.el-button.is-plain) {
//     margin-left: 24px;
//   }
// }
// //最左边的箭头
// :deep(.btn-prev.is-first) {
//   margin-right: 12px;
//   background-color: #f5f6f7;
// }
// :deep(.btn-next) {
//   background-color: #f5f6f7;
// }
// //每个页
// :deep(.number) {
//   margin-right: 12px;
//   // color:#BBBDBF;
//   background-color: #f5f6f7;
// }
// //省略号
// :deep(.more.btn-quicknext.el-icon) {
//   margin-right: 12px;
//   background-color: #f9f9f9;
// }

// .demo-pagination-block + .demo-pagination-block {
//   margin-top: 10px;
// }
// .demo-pagination-block .demonstration {
//   margin-bottom: 16px;
// }
</style>